<template>
  <div>
    <div class="d-flex" id="wrapper">
      <!-- Sidebar -->
      <SideBar/>
      <!-- /#sidebar-wrapper -->
      <!-- Page Content -->
      <div id="page-content-wrapper">
        <nav style="justify-content:flex-start;" class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating">
          <div>
            <button class="btn btn-outline" id="menu-toggle" @click="sidebar"><span class="navbar-toggler-icon"></span>
            </button>

            <button style="color: rgba(0,0,0,.5);border-color: rgba(0,0,0,.1);" class="btn btn-outline navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span style="padding-top:0.5em;"><i class="fas fa-user-alt"></i><span class="account-div"></span><i class="fas fa-angle-down"></i></span>
            </button>
          </div>
          <div class="d-flex">
            <p class="text-muted mb-0 hover-cursor link">&nbsp;Warehouse</p>
                        <p class="text-primary mb-0 hover-cursor">&nbsp;/&nbsp;Inventory Sparepart</p>
          </div>
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
              <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  {{ admin }}
                </a>
                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                  <a class="dropdown-item link" @click="toPage('/password')"> <i class="fas fa-cog"></i><span class="right-dropdown">Change Password</span></a>
                  <a class="dropdown-item link" @click="handleLogout"><i class="fas fa-sign-out-alt"></i><span class="right-dropdown">Logout</span></a>
                </div>
              </li>
            </ul>
          </div>
        </nav>
        <div class="container-fluid mt-3">
          <div class="row">
            <div class="col-md-12 grid-margin stretch-card card-div">
              <div class="container">
                  <div class="d-flex mb-2 flex-wrap">
                    <div class="mr-2">
                      <button class="btn btn-primary mt-4" @click="openModal('Add')"> Add In</button>
                    </div>
                    <div style="width: 161px" class="mr-2">
                        Warehouse
                        <multiselect v-model="searchWarehouse" :options="warehouseOption" label="warehouseName" :allow-empty="false" :select-label="''" :deselect-label="''" placeholder="Warehouse" track-by="warehouseName" :selectedLabel="''"></multiselect>
                    </div>
                    <div class="mr-2" style="width: 161px;">
                        SKU No
                        <input type="text" name="" class="form-control text-field" placeholder="SKU No" v-model="searchSku">
                    </div>
                    <div class="mr-2" style="width:161px">
                        Type
                        <multiselect
                            v-model="searchType"
                            :options="$getProductType('sparepart','all')"
                            label="statusName"
                            :allow-empty="false"
                            :select-label="''"
                            :deselect-label="''"
                            placeholder="Select Type"
                            track-by="statusName"
                            :selectedLabel="''"
                            :optionHeight="30"
                        ></multiselect>
                    </div>
                    <div class="mr-2" style="width:188px;">
                        Name
                        <input type="text" name="" class="form-control text-field" placeholder="Name" v-model="searchName">
                    </div>
                    <div class="mr-2" style="width:161px">
                        Criteria
                        <multiselect 
                            v-model="searchCriteria" 
                            :options="criteriaOption" 
                            label="criteriaName" 
                            :allow-empty="false" 
                            :select-label="''" 
                            :deselect-label="''" 
                            placeholder="Criteria" 
                            track-by="criteriaName" 
                            :selectedLabel="''"
                        ></multiselect>
                    </div>
                    <div>
                        <button class="btn btn-primary mt-4 mr-2" @click="searchData(1)"> Search </button>
                        <button class="btn btn-primary mt-4" @click="resetSearch"> Reset </button>
                    </div>
                  </div>
                <table class="table table-sm table-bordered table-striped table-responsive-sm">
                  <thead class="">
                    <tr>
                      <th style="width: 150px">SKU / Product ID</th>
                      <th>Type</th>
                      <th>Name</th>
                      <th>Total</th>
                      <th>Coming</th>
                      <th>Available</th>
                      <th>Assembled</th>
                      <th>Reserved</th>
                      <th>Used</th>
                      <th>Broken</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="loadingTable === false && dataInvSparepart.length == '0'">
                      <td colspan="11" class="text-center">Data Not Available</td>
                    </tr>
                    <tr v-else-if="loadingTable === true">
                      <td colspan="11" class="text-center"><img src="~@/assets/images/load-button.gif"></td>
                    </tr>
                    <tr v-for="(data,index) in dataInvSparepart" :key="index" v-else>
                      <td>{{ data.sku }}</td>
                      <td>{{ $getConstantsName('PRODUCT_TYPE',data.type) }}</td>
                      <td>{{ data.componentName }}</td>
                      <td>{{ data.total }}</td>
                      <td>{{ data.coming }}</td>
                      <td>{{ data.available }}</td>
                      <td>{{ data.assembled }}</td>
                      <td>{{ data.reserved }}</td>
                      <td>{{ data.used }}</td>
                      <td>{{ data.broken }}</td>
                      <td>
                        <button class="btn btn-primary btn-sm" @click="toDetailPage(data.sku)"> Detail </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="d-flex justify-content-between mt-3">
                  <div class="d-flex align-items-center">
                    <div style="margin-right: 10px;">
                      <select class="form-control form-control-sm" v-model="itemPerPage" @change="searchData(1)">
                              <option value="10">10</option>
                              <option value="40">40</option>
                              <option value="80">80</option>
                      </select>
                    </div>
                    <div class="total-data">
                      Total Data {{ totalData }} 
                    </div>
                  </div>
                  <div>
                    <div class="pagination p8 alignRight">
                      <ul>
                        <a class="is-active link" @click="searchData(parseInt(currentPage)-1)" v-if="currentPage != 1"><li>{{'<'}}</li></a>
                        <a class="page"><li>{{ currentPage }} of {{ totalPage }} page</li></a>
                        <a class="is-active link" @click="searchData(parseInt(currentPage)+1)" v-if="currentPage != totalPage"><li>></li></a>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /#page-content-wrapper -->
      <div class="modal fade" id="modalAdd" role="dialog">
        <div class="modal-dialog modal-dialog-centered">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <div class="change-title">
                <h4 class="modal-title">Add In</h4>
              </div>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
              <div class="d-flex align-items-center">
                <span class="label-text-field">Source</span>
                <multiselect v-model="sourceAddIn" :options="sourceOption" :allow-empty="false" :select-label="'Source'" :deselect-label="''" placeholder="Source" @select="resetAddIn"></multiselect>
              </div>
              <div class="d-flex mt-2 align-items-center">
                <span class="label-text-field-two">Unique ID</span>
                <input type="text" class="form-control text-field" name="uniqueId" v-model="uniqueIdAddIn" placeholder="SKU">
                <button class="btn btn-primary ml-2" @click="getDataAddIn" :disabled="loadingGetAddIn"><img src="~@/assets/images/2.gif" style="height: 18px;margin-right: 1px;" v-if="loadingGetAddIn"><span v-if="!loadingGetAddIn">Get</span></button>
              </div>
              <div class="text-notif text-center" v-if="notFound">
                <hr>
                <span>Data Not Found</span>
              </div>
              <hr v-if="getAddIn">
              <table class="add-in" v-if="getAddIn">
                <tr>
                  <td style="width: 115px;">Source</td>
                  <td style="width: 10px;">:</td>
                  <td>{{ dataGetAddIn[0].source }} {{ dataGetAddIn[0].hash }}</td>
                </tr>
                <tr>
                  <td>SKU</td>
                  <td>:</td>
                  <td>{{ dataGetAddIn[0].sku }}</td>
                </tr>
                <tr>
                  <td>Name</td>
                  <td>:</td>
                  <td> {{ dataGetAddIn[0].componentName }}</td>
                </tr>
                <tr>
                  <td>Qty</td>
                  <td>:</td>
                  <td>
                    <input type="number" name="qty" class="form-control w-50" v-model="qtyAddIn" min="0">
                  </td>
                </tr>
                <!-- Procure -->
                <tr v-if="sourceAddIn === 'Procure'">
                  <td>Procure PIC</td>
                  <td>:</td>
                  <td>{{ dataGetAddIn[0].procurePic }}</td>
                </tr>
                <tr v-if="sourceAddIn === 'Procure'">
                  <td>Courier PIC</td>
                  <td>:</td>
                  <td>{{ dataGetAddIn[0].courierPic }}</td>
                </tr>
                <!-- Procure -->
                <!-- stock opname -->
                <tr v-if="sourceAddIn === 'Stock Opname'">
                  <td>Condition</td>
                  <td>:</td>
                  <td>
                    <multiselect v-model="conditionAddIn" :options="conditionOption" label="conditionName" :allow-empty="false" :select-label="''" :deselect-label="''" placeholder="Condition" track-by="conditionName"></multiselect>
                  </td>
                </tr>
                <!-- stock opname -->
                <!-- My BAG -->
                <tr v-if="sourceAddIn === 'My Bag'">
                  <td>Support PIC</td>
                  <td>:</td>
                  <td>{{ dataGetAddIn[0].pic }}</td>
                </tr>
                <!-- My Bag -->
                <tr v-if="sourceAddIn === 'Stock Opname'">
                  <td>Warehouse</td>
                  <td>:</td>
                  <td class="w-75">
                    <multiselect v-model="warehouseAddIn" :options="warehouseOptionAddIn" label="warehouseName" :allow-empty="false" :select-label="''" :deselect-label="''" placeholder="Select Warehouse" track-by="warehouseName"></multiselect>
                  </td>
                </tr>
              </table>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-success btn-sm" :disabled="loadingDoneAddIn || loadingMore" @click="validateAddIn('more')">
                <img src="~@/assets/images/2.gif" style="height: 18px;margin-right: 1px;" v-if="loadingMore">More Add In
              </button>
              <button type="button" class="btn btn-primary btn-sm" @click="validateAddIn('done')" :disabled="loadingDoneAddIn || loadingMore">
                <img src="~@/assets/images/2.gif" style="height: 18px;margin-right: 1px;" v-if="loadingDoneAddIn">Done
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- endModal -->
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import CONSTANT from '../constPlugin';
import SideBar from '../SideBar'
export default {
  name: 'InventorySparepatPage',
  components:{
    SideBar,
    Multiselect
  },
  data () {
    return {
      spaceRegex: /[\u00A0\uFEFF\u202F]/g,
      admin:"",
      adminId:"",
      permission:[],
      viewInvSparepart:false,
      loadingTable:false,
      loadingGetAddIn:false,
      loadingDoneAddIn:false,
      loadingMore:false,
      dataLog:[],
      dataInvSparepart:[],
      dataWarehouse:[],
      searchWarehouse:{
        warehouseId:'All',
        warehouseName:'All'
      },
      warehouseOption:[],
      warehouseOptionAddIn:[],
      searchSku:'',
      searchType:'',
      searchName:'',
      searchCriteria:{
        criteria:0,
        criteriaName:'Without Criteria'
      },
      criteriaOption:[{
        criteria:0,
        criteriaName:'Without Criteria'
      },
      {
        criteria:1,
        criteriaName:'Available Stock < 10'
      }],
      sourceAddIn:'Procure',
      sourceOption:['Procure','Stock Opname','My Bag'],
      uniqueIdAddIn:'',
      getAddIn:false,
      typeEdit:'',
      nameEdit:'',
      currentPage:1,
      totalPage:1,
      totalData:0,
      itemPerPage:10,
      dataGetAddIn:[],
      qtyAddIn:0,
      notFound:false,
      conditionAddIn:{
        condition:0,
        conditionName:'Available'
      },
      conditionOption:[
      {
        condition:0,
        conditionName:'Available'
      },
      {
        condition:1,
        conditionName:'Broken'
      }
      ],
      warehouseAddIn:[],
    }
  },
  methods: {
    toDetailPage(sku){
      this.$router.push({path:'/inventory/sparepart/detail/'+sku, query: {
              status:'All',
              warehouseId:this.searchWarehouse.warehouseId,
              warehouseName:this.searchWarehouse.warehouseName,
              page:1,
              itemPerPage:10
          }
      })
    },
    getDataAddIn(){
      this.loadingGetAddIn = true
      var self = this
      this.$http.post(process.env.GET_INFO_ITEM,{
          type:this.sourceAddIn,
          uniqueId: this.uniqueIdAddIn,
      },{
        headers: {'Asani-Token':localStorage.getItem('jwt')}
      })
      .then(response => {
        if (response.data.status == 400) {
              swal("Sorry", response.data.message, "error", {
                    button: "Ok",
                  })

            } else{
              this.loadingGetAddIn = false
              this.dataGetAddIn = response.data.content
              if (this.dataGetAddIn.length != 0) {
                this.getAddIn = true
                this.qtyAddIn = this.dataGetAddIn[0].qty
                this.notFound = false
              } else{
                this.notFound = true
              }
            }
      })
      .catch(error => {
        self.loadingGetAddIn = false
        alert('Error with API')
        swal("Sorry", error.response.data.message, "error", {
          button: "Ok",
        }).then(v => {
          if(error.response.data.status == 401) {
            this.handleLogout()
          }
        })
      })
    },
    resetAddIn(){
      this.dataGetAddIn = []
      this.getAddIn = false
      this.qtyAddIn = 0
      this.uniqueIdAddIn = ''
      this.notFound = false
      this.loadingDoneAddIn = false
      this.loadingMore = false
      this.warehouseAddIn = []
    },
    validateAddIn(btnChoose){
      if (this.qtyAddIn != 0) {
        if (this.sourceAddIn == 'Stock Opname' && this.warehouseAddIn.length != 0) {
          this.submitAddIn(btnChoose)
        }else{
          swal("Sorry", 'Warehouse must be choose', "error", {
            button: "Ok",
          })
        }
        if (this.sourceAddIn != 'Stock Opname') {
          this.submitAddIn(btnChoose)
        }
      }else{
        swal("Sorry", 'minimum qty 1', "error", {
          button: "Ok",
        })
      }
    },
    submitAddIn(btnChoose){
      if (btnChoose == 'done') {
        // $("#modalAdd").modal('hide')
        this.loadingDoneAddIn = true
      }else{
        this.loadingMore = true
      }
      var self = this
      this.$http.post(process.env.INVENTORY_SPAREPART_ADD_IN,{
          type:this.sourceAddIn,
          uniqueId: this.uniqueIdAddIn,
          qty: this.qtyAddIn,
          warehouseId: this.warehouseAddIn.warehouseId,
          condition: this.conditionAddIn.condition,
          sparepartName: this.dataGetAddIn[0].componentName
      },{
        headers: {'Asani-Token':localStorage.getItem('jwt')}
      })
      .then(response => {
        if (response.data.status == 400) {
              swal("Sorry", response.data.message, "error", {
                    button: "Ok",
                  })

        } else if (response.data.status == 201) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          this.loadingDoneAddIn = false
          this.loadingMore = false
        }else{
          swal("Success", response.data.message, "success", {
              button: "Close",
          });
          if (btnChoose == 'done') {
            $("#modalAdd").modal('hide')
            this.loadingDoneAddIn = false
          }else{
            this.loadingMore = false
          }
          this.resetAddIn()
          this.getData()
        }
      })
      .catch(error => {
        self.loadingDoneAddIn = false
        self.loadingMore = false
        alert('Error with API')
        swal("Sorry", error.response.data.message, "error", {
          button: "Ok",
        }).then(v => {
          if(error.response.data.status == 401) {
            this.handleLogout()
          }
        })
      })
    },
    resetSearch(){
      this.searchWarehouse = {
        warehouseId:'All',
        warehouseName:'All'
      };
      this.searchSku = '';
      this.searchName = '';
      this.searchType = CONSTANT.ALL;
      this.searchCriteria = {
        criteria:0,
        criteriaName:'Without Criteria'
      };
      this.currentPage = 1;
      this.searchData(1);
    },
    openModal(modalName) {
      $("#modal"+modalName).modal('show')
      this.resetAddIn()
    },
    searchData(pagePost){
      if (this.searchType == null) {
          this.searchType = CONSTANT.ALL
      }
      this.$router.push({
          path: "/inventory/sparepart",
          query: {
              warehouseId: this.searchWarehouse.warehouseId,
              warehouseName: this.searchWarehouse.warehouseName,
              sku: this.searchSku,
              type: this.searchType.status,
              name: this.searchName,
              criteria: this.searchCriteria.criteria,
              page: pagePost,
              itemPerPage: this.itemPerPage
          },
      });
    },
    toPage(e) {
      this.$router.push(e)
    },
    async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
      localStorage.removeItem('jwt')
      localStorage.removeItem('admin_name')
      localStorage.removeItem('roles')
      localStorage.removeItem('user_email')
      localStorage.removeItem('admin_id')
      localStorage.removeItem('changeCatalogPermission')
      this.$router.push('/')
    },
    cekLogin(){
      if (localStorage.getItem('jwt') == null) {
        this.$router.push('/')
      }
    },
    cekPermission(){
      this.permission = localStorage.getItem('roles').replace(/"/g,"").replace("[","").replace("]","").split(",")
      for(var i=0; i < this.permission.length; i++){
        if( this.permission[i] == "1"){
          this.viewInvSparepart = true
        }
          this.viewInvSparepart = true
      }
      if (this.viewInvSparepart == false) {
        this.$router.push('/')
      }
    },
    sidebar(){
      $("#wrapper").toggleClass("toggled");
    },
    getData(){
      this.loadingTable = true
      this.searchWarehouse = {
        warehouseId : this.$route.query.warehouseId,
        warehouseName : this.$route.query.warehouseName
      }
      this.searchSku = this.$route.query.sku;
      this.searchName = this.$route.query.name;
      this.searchType = this.$getConstantsObjectS('PRODUCT_TYPE',this.$route.query.type);
      if(this.$route.query.criteria == 0){
        this.searchCriteria = {
          criteria: this.$route.query.criteria,
          criteriaName: 'Without Criteria'
        };
      }else if (this.$route.query.criteria == 1) {
        this.searchCriteria = {
          criteria: this.$route.query.criteria,
          criteriaName: 'Available Stock < 10'
        };
      }
      this.currentPage = parseInt(this.$route.query.page);
      this.itemPerPage = parseInt(this.$route.query.itemPerPage);
      this.$http.post(process.env.SEARCH_INVENTORY_SPAREPART,{
          warehouseId:this.searchWarehouse.warehouseId,
          sku: this.searchSku !== null ? this.searchSku.replace(this.spaceRegex, ' ') : this.searchSku,
          type: this.searchType.status,
          name: this.searchName !== null ? this.searchName.replace(this.spaceRegex, ' ') : this.searchName,
          criteria: this.searchCriteria.criteria,
          page: 1,
          itemPerPage: this.itemPerPage
      },{
        headers: {'Asani-Token':localStorage.getItem('jwt')}
      })
      .then(response => {
        if (response.data.status == 400) {
              swal("Sorry", response.data.message, "error", {
                    button: "Ok",
                  })
            }else{
              this.dataInvSparepart = response.data.content.data
              this.warehouseOption = []
              this.warehouseOption.push({
                  warehouseId : 'All',
                  warehouseName : 'All'
              })
              this.warehouseOptionAddIn = []
              for (var i = 0; i < response.data.content.dataWarehouse.length; i++) {
                this.warehouseOption.push({
                  warehouseId : response.data.content.dataWarehouse[i].warehouseId,
                  warehouseName : response.data.content.dataWarehouse[i].warehouseName
                })
                this.warehouseOptionAddIn.push({
                  warehouseId : response.data.content.dataWarehouse[i].warehouseId,
                  warehouseName : response.data.content.dataWarehouse[i].warehouseName
                })
              }
              this.totalPage = response.data.content.totalPage
              this.currentPage = response.data.content.currentPage
              this.totalData = response.data.content.totalData
              this.loadingTable = false
            }
      })
      .catch(error => {
        swal("Sorry", error.response.data.message, "error", {
          button: "Ok",
        }).then(v => {
          if(error.response.data.status == 401) {
            this.handleLogout()
          }
        })
      })
    },
  },
  created(){
    this.getData()
    this.admin = localStorage.getItem('admin_name')
    this.adminId = localStorage.getItem('admin_id')
    this.cekLogin()
    this.cekPermission()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .text-notif{
    color: red;
    font-size: 12px;
    margin-top: 10px;
    font-weight: bold;
  }
  table.add-in tr td{
    height: 42.2px;
  }
  .text-field{
    height: 42.2px;
  }
  .label-text-field{
    width: 100px;
  }
  .label-text-field-two{
    width: 121px;
  }
  .pagination{
    padding: 0px 0;
  }

  .pagination ul{
    margin: 0;
    padding: 0;
    list-style-type: none;
  }

  .pagination a{
    display: inline-block;
    padding: 1px 6px;
    color: #222;
  }

  .p8 a{
    background-color: #2797FB;
    color: #fff;
    border: 1px solid #2797FB;
  }

  .p8 a:hover{
    text-decoration: none;
  }
  .p8 a.page:hover{
    text-decoration: none;
    color: #fff;
  }

  .p8 .is-active{
    background-color: #fff;
    color: #2797FB;
  }

  .total-data{
    font-size: 14px;
    color: #343A40;
  }
</style>



// WEBPACK FOOTER //
// src/components/Warehouse/InventorySparepartPage.vue